import { SagaIterator } from 'redux-saga';
import { FEEDBACK_SEND, FEEDBACK_TRIGGER } from 'src/modules/feedback/actions/FeedbackActions';
import { feedbackSendSaga } from 'src/modules/feedback/sagas/feedbackSendSaga';
import { feedbackTriggerRequestSaga } from 'src/modules/feedback/sagas/feedbackTriggerRequestSaga';
import { takeLatest } from 'typed-redux-saga';

export function* feedbackSaga(): SagaIterator<void> {
  yield* takeLatest(FEEDBACK_TRIGGER.isRequest, feedbackTriggerRequestSaga);

  yield* takeLatest(FEEDBACK_SEND.isRequest, feedbackSendSaga);
}
